import React, { createContext, useState, PropsWithChildren } from 'react';
import {
    AverageSalesByHour,
    AverageSalesByDayOfWeekItem,
    TopProductStat,
    SellerPerformanceItem,
    TodaySalesByHourItem,
    YearSalesByMonthItem,
    WeekSalesByDayItem,
    MonthSalesByWeekItem,
    OrganisationMontlyRevenue
} from '@utilities/types';

interface DashboardContextType {
    yearSalesByMonth: YearSalesByMonthItem[];
    setYearSalesByMonth: React.Dispatch<React.SetStateAction<YearSalesByMonthItem[]>>;
    monthSalesByWeek: MonthSalesByWeekItem[];
    setMonthSalesByWeek: React.Dispatch<React.SetStateAction<MonthSalesByWeekItem[]>>;
    weekSalesByDay: WeekSalesByDayItem[];
    setWeekSalesByDay: React.Dispatch<React.SetStateAction<WeekSalesByDayItem[]>>;
    todaySalesByHour: TodaySalesByHourItem[];
    setTodaySalesByHour: React.Dispatch<React.SetStateAction<TodaySalesByHourItem[]>>;
    topProductsStats: TopProductStat[];
    setTopProductsStats: React.Dispatch<React.SetStateAction<TopProductStat[]>>;
    averageSalesByHour: AverageSalesByHour[];
    setAverageSalesByHour: React.Dispatch<React.SetStateAction<AverageSalesByHour[]>>;
    averageSalesByDayOfWeek: AverageSalesByDayOfWeekItem[];
    setAverageSalesByDayOfWeek: React.Dispatch<React.SetStateAction<AverageSalesByDayOfWeekItem[]>>;
    sellerPerformance: SellerPerformanceItem[];
    setSellerPerformance: React.Dispatch<React.SetStateAction<SellerPerformanceItem[]>>;
    organisationMontlyRevenue: OrganisationMontlyRevenue | null;
    setOrganisationMontlyRevenue: React.Dispatch<React.SetStateAction<OrganisationMontlyRevenue | null>>;
}

export const DashboardContext = createContext<DashboardContextType>({
    yearSalesByMonth: [],
    setYearSalesByMonth: () => { },
    monthSalesByWeek: [],
    setMonthSalesByWeek: () => { },
    weekSalesByDay: [],
    setWeekSalesByDay: () => { },
    todaySalesByHour: [],
    setTodaySalesByHour: () => { },
    topProductsStats: [],
    setTopProductsStats: () => { },
    averageSalesByHour: [],
    setAverageSalesByHour: () => { },
    averageSalesByDayOfWeek: [],
    setAverageSalesByDayOfWeek: () => { },
    sellerPerformance: [],
    setSellerPerformance: () => { },
    organisationMontlyRevenue: null,
    setOrganisationMontlyRevenue: () => { }
});

export const DashboardContextProvider: React.FC<PropsWithChildren> = ({ children }) => {

    const [yearSalesByMonth, setYearSalesByMonth] = useState<YearSalesByMonthItem[]>([]);
    const [monthSalesByWeek, setMonthSalesByWeek] = useState<MonthSalesByWeekItem[]>([]);
    const [weekSalesByDay, setWeekSalesByDay] = useState<WeekSalesByDayItem[]>([]);
    const [todaySalesByHour, setTodaySalesByHour] = useState<TodaySalesByHourItem[]>([]);
    const [topProductsStats, setTopProductsStats] = useState<TopProductStat[]>([]);
    const [averageSalesByHour, setAverageSalesByHour] = useState<AverageSalesByHour[]>([]);
    const [averageSalesByDayOfWeek, setAverageSalesByDayOfWeek] = useState<AverageSalesByDayOfWeekItem[]>([]);
    const [sellerPerformance, setSellerPerformance] = useState<SellerPerformanceItem[]>([]);
    const [organisationMontlyRevenue, setOrganisationMontlyRevenue] = useState<OrganisationMontlyRevenue | null>(null);

    return (
        <DashboardContext.Provider value={{
            yearSalesByMonth, setYearSalesByMonth,
            monthSalesByWeek, setMonthSalesByWeek,
            weekSalesByDay, setWeekSalesByDay,
            todaySalesByHour, setTodaySalesByHour,
            topProductsStats, setTopProductsStats,
            averageSalesByHour, setAverageSalesByHour,
            averageSalesByDayOfWeek, setAverageSalesByDayOfWeek,
            sellerPerformance, setSellerPerformance,
            organisationMontlyRevenue, setOrganisationMontlyRevenue
        }}>
            {children}
        </DashboardContext.Provider>
    );
};
